var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": {
          minWidth: _vm.getMinWidth,
          maxWidth: _vm.getMaxWidth,
          minHeight: "90vh"
        },
        "no-backdrop-dismiss": "",
        "no-esc-dismiss": ""
      },
      on: {
        hide: function($event) {
          return _vm.clearSale()
        }
      },
      model: {
        value: _vm.show_insert_sale,
        callback: function($$v) {
          _vm.show_insert_sale = $$v
        },
        expression: "show_insert_sale"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    _vm.show_insert_sale = false
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("insert_user_sale")) +
                    "\n            "
                )
              ])
            ],
            1
          ),
          _c("div", { staticClass: "layout-padding" }, [
            _c(
              "div",
              { staticClass: "row gutter-sm" },
              [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("q-select", {
                      attrs: {
                        filter: "",
                        options: _vm.companies,
                        "float-label": _vm.$t("retailer") + "*",
                        error: _vm.$v.company.$error
                      },
                      on: {
                        input: function($event) {
                          return _vm.changeCompany()
                        }
                      },
                      model: {
                        value: _vm.company,
                        callback: function($$v) {
                          _vm.company = $$v
                        },
                        expression: "company"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("q-select", {
                      attrs: {
                        filter: "",
                        options: _vm.branches,
                        "float-label": _vm.$t("store") + "*",
                        error: _vm.$v.branch.$error
                      },
                      on: { input: _vm.$v.branch.$touch },
                      model: {
                        value: _vm.branch,
                        callback: function($$v) {
                          _vm.branch = $$v
                        },
                        expression: "branch"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6" },
                  [
                    _c("q-datetime", {
                      attrs: {
                        type: "date",
                        "float-label": _vm.$t("sale_date") + "*",
                        format: "DD/MM/YYYY",
                        error: _vm.$v.sale_date.$error,
                        min: _vm.mininum_date,
                        max: _vm.maximum_date
                      },
                      on: { input: _vm.$v.sale_date.$touch },
                      model: {
                        value: _vm.sale_date,
                        callback: function($$v) {
                          _vm.sale_date = $$v
                        },
                        expression: "sale_date"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6" },
                  [
                    _c(
                      "q-field",
                      {
                        attrs: {
                          error: _vm.order_number_error,
                          "error-label": _vm.$t(
                            "the_note_number_has_already_been_sent_by_the_user_before"
                          )
                        }
                      },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": _vm.$t("invoice_number") + "*",
                            error: _vm.$v.order_number.$error
                          },
                          on: {
                            input: _vm.$v.order_number.$touch,
                            blur: function($event) {
                              return _vm.orderNumberUnique()
                            }
                          },
                          model: {
                            value: _vm.order_number,
                            callback: function($$v) {
                              _vm.order_number = $$v
                            },
                            expression: "order_number"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("p", { staticClass: "caption" }, [
                      _vm._v(_vm._s(_vm.$t("upload_invoice")))
                    ]),
                    _c("uploader", {
                      attrs: {
                        content_type: "images",
                        multiple: false,
                        cropper: false
                      },
                      on: { fileUploaded: _vm.fileUploaded }
                    })
                  ],
                  1
                ),
                _vm.sale_images.length > 0
                  ? _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        { staticClass: "row gutter-sm" },
                        _vm._l(_vm.sale_images, function(sale_image, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "col-xs-4 col-sm-2" },
                            [
                              _c("img", {
                                staticStyle: {
                                  "max-width": "100%",
                                  height: "auto"
                                },
                                attrs: { src: sale_image }
                              }),
                              _c("q-btn", {
                                staticClass: "full-width",
                                attrs: {
                                  dense: "",
                                  icon: "fal fa-times",
                                  label: _vm.$t("remove_image"),
                                  color: "negative"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeUserSaleImage(index)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("q-input", {
                      attrs: {
                        "float-label": _vm.$t("observation"),
                        type: "textarea"
                      },
                      model: {
                        value: _vm.observation,
                        callback: function($$v) {
                          _vm.observation = $$v
                        },
                        expression: "observation"
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "col-12 caption" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("detail_sold_products")) +
                      "\n                "
                  )
                ]),
                _vm._l(_vm.products, function(p, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "col-12" },
                    [
                      _c(
                        "q-card",
                        [
                          _c("q-card-main", [
                            _c(
                              "div",
                              { staticClass: "row gutter-sm justify-end" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-xs-12 col-sm-6" },
                                  [
                                    _c("q-select", {
                                      attrs: {
                                        options: _vm.brands,
                                        "float-label": _vm.$t("brand") + "*",
                                        error:
                                          _vm.$v.products.$each[index].brand
                                            .$error
                                      },
                                      on: {
                                        input:
                                          _vm.$v.products.$each[index].brand
                                            .$touch
                                      },
                                      model: {
                                        value: p.brand,
                                        callback: function($$v) {
                                          _vm.$set(p, "brand", $$v)
                                        },
                                        expression: "p.brand"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-12 col-sm-6" },
                                  [
                                    _c("q-select", {
                                      attrs: {
                                        options: _vm.product_types,
                                        "float-label":
                                          _vm.$t("product_type") + "*",
                                        error:
                                          _vm.$v.products.$each[index]
                                            .product_type.$error
                                      },
                                      on: {
                                        input:
                                          _vm.$v.products.$each[index]
                                            .product_type.$touch
                                      },
                                      model: {
                                        value: p.product_type,
                                        callback: function($$v) {
                                          _vm.$set(p, "product_type", $$v)
                                        },
                                        expression: "p.product_type"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-12 col-sm-6" },
                                  [
                                    _c("q-select", {
                                      attrs: {
                                        options: _vm.processors,
                                        "float-label":
                                          _vm.$t("processor") + "*",
                                        error:
                                          _vm.$v.products.$each[index].product
                                            .$error
                                      },
                                      on: {
                                        input:
                                          _vm.$v.products.$each[index].product
                                            .$touch
                                      },
                                      model: {
                                        value: p.product,
                                        callback: function($$v) {
                                          _vm.$set(p, "product", $$v)
                                        },
                                        expression: "p.product"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-12 col-sm-6" },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        "float-label": _vm.$t("sku") + "*",
                                        error:
                                          _vm.$v.products.$each[index]
                                            .product_code.$error
                                      },
                                      on: {
                                        input:
                                          _vm.$v.products.$each[index]
                                            .product_code.$touch
                                      },
                                      model: {
                                        value: p.product_code,
                                        callback: function($$v) {
                                          _vm.$set(p, "product_code", $$v)
                                        },
                                        expression: "p.product_code"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-12 col-sm-6" },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        "float-label": _vm.$t("quantity") + "*",
                                        type: "number",
                                        error:
                                          _vm.$v.products.$each[index].quantity
                                            .$error
                                      },
                                      on: {
                                        input:
                                          _vm.$v.products.$each[index].quantity
                                            .$touch
                                      },
                                      model: {
                                        value: p.quantity,
                                        callback: function($$v) {
                                          _vm.$set(p, "quantity", $$v)
                                        },
                                        expression: "p.quantity"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-xs-12 col-sm-6" },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        disable: "",
                                        "float-label": _vm.$t(
                                          "quantity_points"
                                        ),
                                        type: "number",
                                        value: _vm.calculatePoints(p)
                                      }
                                    })
                                  ],
                                  1
                                ),
                                index > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "col-12" },
                                      [
                                        _c("q-btn", {
                                          attrs: {
                                            label: _vm.$t("remove_product"),
                                            color: "negative"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeProduct(index)
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("q-btn", {
                      attrs: {
                        color: "secondary",
                        label: _vm.$t("add_new_product")
                      },
                      on: {
                        click: function($event) {
                          return _vm.addProduct()
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12 text-right" },
                  [
                    _c("q-btn", {
                      attrs: {
                        label: _vm.$t("insert_sale"),
                        color: "positive"
                      },
                      on: {
                        click: function($event) {
                          return _vm.submitUserData()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              2
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }